import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'input[app-switch]',
  templateUrl: './switch.component.html',
  styleUrls: ['./switch.component.scss'],
  host: {
    type: 'checkbox',
    class: 'app-switch',
  },
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SwitchComponent {}
